<template>
  <v-container fluid grid-list-sm>
    <v-layout row wrap>
      <v-flex xs10>

        <v-tooltip top>
          <v-btn icon class="mx-0" slot="activator"
                 @click="() => { submitDbid = item.dbid; submitMsg = item.name; submit = true; }"
                 :disabled="submitDisabled(item)">
            <v-icon color="teal">publish</v-icon>
          </v-btn>
          <span>提交</span>
        </v-tooltip>

        <v-tooltip top>
          <v-btn icon class="mx-0" slot="activator"
                 @click="() => { reviewDbid = item.dbid; reviewMsg = item.name; reviewActs = item.actions; review = true; }"
                 :disabled="reviewDisabled(item)">
            <v-icon color="teal">playlist_add_check</v-icon>
          </v-btn>
          <span>审核</span>
        </v-tooltip>

        <v-tooltip top>
          <v-btn icon class="mx-0" slot="activator"
                 @click="() => { deleDbid = item.dbid; deleMsg = item.name; dele = true; }"
                 :disabled="deleteDisabled(item)">
            <v-icon color="pink">delete_forever</v-icon>
          </v-btn>
          <span>删除</span>
        </v-tooltip>

        <v-tooltip top>
          <v-chip small label class="mx-0" slot="activator"
                  :color="item.status.color"
                  @click="() => { history=item.history; hist = true; }">
            {{ item.status.name }}
          </v-chip>
          <span>点击查看审核历史</span>
        </v-tooltip>

        <x-submit
            v-model="submit"
            :dbid="submitDbid"
            :message="submitMsg"
            :uri="uri"
            @ok="(it) => Object.assign(item,it)"
        />

        <x-review
            v-model="review"
            :dbid="reviewDbid"
            :message="reviewMsg"
            :uri="uri"
            :actions="reviewActs"
            @ok="(it) => Object.assign(item,it)"
        />

        <x-delete
            v-model="dele"
            :message="deleMsg"
            :uri="uri"
            :dbid="deleDbid"
            v-on:ok="$router.push('/proj/project')"
        />

        <x-history
            v-model="hist"
            :history="history"
            :status="statusItems"
        />
      </v-flex>

      <v-flex xs2>
        <v-btn
            flat round color="primary" dark
            @click="prev">
          <v-icon>first_page</v-icon>
          返回
        </v-btn>
      </v-flex>

      <v-flex xs12>
        <basic :project="item"/>
      </v-flex>

      <!--
      <v-flex xs12>
        <contract v-model="item.contract"/>
      </v-flex>
      -->

      <v-flex d-flex xs12 sm12 md12 lg7>
        <v-layout row wrap>
          <v-flex xs12 d-flex>
            <income :project="item"/>
          </v-flex>

          <v-flex xs12 d-flex>
            <member :project="item"/>
          </v-flex>

          <v-flex xs12 d-flex>
            <attachment :project="item"/>
          </v-flex>

        </v-layout>
      </v-flex>

      <v-flex d-flex xs12 sm12 md12 lg5>
        <v-layout row wrap>
          <v-flex xs12 d-flex>
            <budget :project="item"></budget>
          </v-flex>
          <v-flex xs12 d-flex>
            <zcmx :project="item"/>
          </v-flex>
        </v-layout>
      </v-flex>

      <!--
      <v-flex d-flex xs12 sm7 md7>
        <change v-model="item.changes"></change>
      </v-flex>
      -->

      <v-flex d-flex xs12 sm12 md12 lg7>
        <conclusion :project="item"/>
      </v-flex>

      <v-flex d-flex xs12 sm12 md12 lg5>
        <event :project="item"/>
      </v-flex>


    </v-layout>
  </v-container>
</template>

<script>
import Vue from 'vue'
import {mapGetters} from 'vuex'

import Basic from './basic/Basic'
import Income from './inco/Income'
import Member from './memb/Member'
import Event from './event/Event'
import Conclusion from './concl/Conclusion'
import Attachment from './attac/Attachment'

// import Change from './widgets/Change'
// import Contract from './widgets/Contract'
import Budget from './budget/Budget'

import XDelete from '@/components/global/Delete'
import XReview from '@/components/global/Review'
import XSubmit from '@/components/global/Submit'
import XHistory from '@/components/global/History'

import Zcmx from './cw_zcmx/Zcmx'

const baseUri = '/api/proj/project';
const statusUri = '/api/code/status';

export default {
  components: {
    XSubmit, XReview, XHistory, XDelete,
    Basic, Income, Member, Attachment, Event,
    Zcmx, Conclusion, Budget
  },

  data: () => ({
    uri: baseUri,
    item: {
      incomes: [],
      members: [],
      attachments: [],
      histories: [],
      changes: [],
      contract: {},
      bugets: {},
      concluding: {},

      status: {},
      actions: []
    },

    fileUri: '/api/proj/file',

    statusItems: [],

    submit: false,
    submitDbid: null,
    submitMsg: null,

    review: false,
    reviewDbid: null,
    reviewMsg: null,
    reviewActs: [],

    dele: false,
    deleDbid: null,
    deleMsg: null,

    hist: false,
    history: [],

  }),

  // 路由进入前，组件就未完成渲染，不可以使用 this
  beforeRouteEnter(to, from, next) {
    window.console.log("In edit_page beforeRouteEnter");
    const dbid = to.params.dbid;
    if (dbid) {
      //获取基本信息
      Vue.axios.get(`${baseUri}/${dbid}`)
          .then(
              rsp => next(vm => {
                vm.dbid = dbid;
                vm.item = rsp.data;
                // 保存默认数据
                vm.defaultItem = window.xutil.clone(vm.item);
                vm.loading = false
              })
          )

    } else {
      next();
    }
  },

  // 路由改变前，组件就已经渲染完成，可以使用 this
  beforeRouteUpdate(to, from, next) {
    window.console.log("In edit_page beforeRouteUpdate");

    const dbid = to.params.dbid;

    if (dbid) {
      this.loading = true;
      Vue.axios.get(`${baseUri}/${dbid}`)
          .then(
              rsp => {
                this.dbid = dbid;
                this.item = rsp.data;
                // 保存默认数据
                this.defaultItem = window.xutil.clone(this.item);
                this.loading = false;
                next()
              }
          )
    } else {
      next();
    }
  },

  computed: {
    ...mapGetters(['funcIds'])
  },

  created() {
    // 加载审核状态
    this.axios.get(statusUri, {params: {sort: 'rank.asc'}})
        .then(
            rspStaus => {
              this.statusItems = rspStaus.data.items;
            }
        )
  },

  methods: {
    submitDisabled(item) {
      return !(
          // 当前用户拥有提交功能
          (this.funcIds.includes('c_proj_project') || this.funcIds.includes('u_proj_project'))
          // 并且，当前记录需要提交
          && item.actions.find(a => a.action === 'submit'))
    },
    reviewDisabled(item) {
      return !(
          // 当前用户拥有审核功能
          this.funcIds.includes('u_proj_project')
          // 并且，当前记录需要审核
          && item.actions.find(a => ['approve', 'return', 'revoke'].includes(a.action)))
    },
    deleteDisabled(item) {
      return !(
          // 当前用户拥有审核功能
          this.funcIds.includes('d_proj_project')
          // 并且，当前记录需要审核
          && item.actions.find(a => ['submit'].includes(a.action)))
    },
    prev(){
      this.$router.go(-1)
    }
  }
}
</script>
<style>
div.dense table.datatable.table td:first-child,
div.dense table.datatable.table td:not(:first-child),
div.dense table.datatable.table th:first-child,
div.dense table.datatable.table th:not(:first-child) {
  padding: 0 8px;
}
</style>
